import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import me from "../images/me.png";


function About() {
  return (
    <div className="background-image-wrapper">
      <Container className="my-5">
        <Row className="row-mobile justify-content-center">
          <Col
            md={5}
            className="offset-md-5 mobile-margin"
            style={{ marginTop: "300px" }}
          >
            <h1>I'm Amalina Hashim</h1>
            <p className="lead">
              <span className="text-colored">Innovation</span> and{" "}
              <span className="text-colored">digital experience </span>
              strategist. Welcome to my page. I specialize in rapid prototyping,
              product management and digital solutions.
            </p>
          </Col>
          <Col md={3} className="align-self-end mb-5">
            <div className="image-wrapper">
              <img
                src={me}
                alt="me"
                className="img-fluid"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About;